import { useNavigate } from "react-router-dom";
import "./ComingSoon.css";

const ComingSoon = () => {
  const navigate = useNavigate();

  return (
    <div className="coming-soon">
      <div className="coming-soon-content">
        <h1>🚧 Coming Soon 🚧</h1>
        <h2>We’re working hard to bring something amazing!</h2>
        <p>Stay tuned — this page is under construction.</p>
        <button className="btn btn-primary" onClick={() => navigate("/")}>
          Back to Home
        </button>
      </div>
    </div>
  );
};

export default ComingSoon;
